import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import {FooterLocaleAndRegionSwitcher} from '@frontend/modules/layout/footer/FooterLocaleAndRegionSwitcher'
import clsx from 'clsx'
import {Link} from 'react-router-dom'

interface FooterNavigationForServicePagesProps {
    className?: string
}

// Навигация по сервисным страницам сервиса.
export function FooterNavigationForServicePages(props: FooterNavigationForServicePagesProps) {

    const {
        className = clsx(
            'mt-1 d-flex flex-column-reverse gap-1',
            'mt-md-0 gap-md-0 flex-md-column',
            'flex-xxl-column-reverse gap-xxl-2'
        ),
    } = props

    return (
        <nav
            className={clsx(
                'footer-links-bottom fs-7',
                className
            )}
        >
            <FooterLocaleAndRegionSwitcher />
            <nav
                className={clsx(
                    'd-flex flex-column gap-1 text-center',
                    'text-md-start',
                    'gap-xxl-5 flex-xxl-row align-items-xxl-start'
                )}
            >
                <Link to={appUrl().support.buySellProcess}>
                    {trans().common.footer.terms_of_service}
                </Link>
                <Link to={appUrl().support.privacyPolicy}>
                    {trans().common.footer.privacy_policy}
                </Link>
                <Link to={appUrl().support.disputeResolution}>
                    {trans().common.footer.dispute_resolution}
                </Link>
            </nav>
        </nav>
    )
}
